// YUNTI default content — used as the first paint fallback and as the CMS seed.
// After the CMS publishes content, the live site reads from the API instead.

export const DEFAULT_CONTENT = {
  brand: {
    name: 'YUNTI',
    tagline: '',
    intro: 'An exploration in individuality, perspective, and unconventional self-expression.',
  },
  nav: { brand: 'Brand', drop: 'Drop 001', collection: 'Collection', contact: 'Contact' },
  hero: {
    reflection: 'UNITY',
    lines: ['You can reflect.', 'You can be mirrored.', 'And still be uniquely You.'],
    cta: 'Shop Perspective',
    meta: [
      'EDITION: DROP 001',
      'CONCEPT: INDIVIDUALITY & PERSPECTIVE',
      'COLLECTION: PERSPECTIVE',
      'ONLINE ANYWHERE',
    ],
  },
  statement: {
    eyebrow: 'Statement / 001',
    diagram_top: '[ PERSPECTIVE ]',
    diagram_middle: '',
    diagram_bottom: '',
    lines: [
      { text: 'Ever think backwards?', style: 'ink' },
      { text: 'Weird, right?', style: 'green' },
      { text: 'So is YUNTI.', style: 'purple' },
      { text: 'Perspective changes things.', style: 'ink' },
      { text: 'Sometimes all it takes is looking again.', style: 'soft' },
    ],
  },
  perspective: {
    eyebrow: 'Drop 001',
    title: 'PERSPECTIVE',
    support: 'Not everything is what it first appears to be.',
    pieces: [
      {
        id: 'piece-1',
        label: 'PIECE // 01',
        tag: 'Humor & Irony',
        line1: '“Damn, you bruised my ego.',
        line2: 'I thought I gave you the remember me strokes.”',
        footnote: 'CONCEPT: SELF-EXPRESSION',
        variant: 'light',
      },
      {
        id: 'piece-2',
        label: 'PIECE // 02',
        tag: 'Self-Awareness',
        line1: '“Things notice me.',
        line2: 'I know, right?”',
        footnote: 'CONCEPT: INVERTED ATTENTION',
        variant: 'dark',
      },
      {
        id: 'piece-3',
        label: 'PIECE // 03',
        tag: 'Comfort in Self',
        line1: '“Self Served.',
        line2: 'Eating effortlessly, of course.”',
        footnote: 'CONCEPT: COMFORT IN SELF',
        variant: 'green',
      },
      {
        id: 'piece-4',
        label: 'PIECE // 04',
        tag: 'The Core Pivot',
        line1: '“Without U...',
        line2: 'There’s only NITY.”',
        footnote: 'CONCEPT: INDIVIDUALITY COMPLETES UNITY',
        variant: 'purple',
      },
    ],
  },
  theWay: {
    badge: 'The YUNTI Way',
    lines: [
      { text: 'Reflect.', style: 'white' },
      { text: 'Be mirrored.', style: 'dim' },
      { text: 'Still be uniquely You.', style: 'purple' },
    ],
    tokens: ['UNITY', 'PERSPECTIVE', 'UNIQUE'],
  },
  products: {
    eyebrow: 'Collection Previews',
    title: 'Featured Products',
    note: 'Drop 001 Preview Mode • Storefront Initializing',
    notice: 'NOTICE: Product photography and cart connection are in preparation for Drop 001 launch.',
    noticeAccent: 'NO PRICING DISPLAYED BEFORE LAUNCH',
    previewLabel: 'Preview',
    previewSub: 'Product preview • Details coming with Drop 001',
    items: [
      {
        id: 'tshirts',
        name: 'T-Shirts',
        badge: 'Drop 001 • Preview',
        image:
          'https://images.unsplash.com/photo-1636047250452-6772f6144b3d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwyfHxzdHJlZXR3ZWFyJTIwb3ZlcnNpemVkJTIwdC1zaGlydHxlbnwwfHx8fDE3OTI5NzE4NTR8MA&ixlib=rb-4.1.0&q=85',
        alt: 'T-shirt preview — stand-in photography',
      },
      {
        id: 'hoodies',
        name: 'Hoodies',
        badge: 'Drop 001 • Preview',
        image:
          'https://images.unsplash.com/photo-1564557287817-3785e38ec1f5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwxfHxzdHJlZXR3ZWFyJTIwYm94eSUyMGhvb2RpZXxlbnwwfHx8fDE3OTI5NzE4NTR8MA&ixlib=rb-4.1.0&q=85',
        alt: 'Hoodie preview — stand-in photography',
      },
      {
        id: 'shorts',
        name: 'Shorts',
        badge: 'Drop 001 • Preview',
        image:
          'https://images.unsplash.com/photo-1789110519919-ac034e2a0986?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHxzdHJlZXR3ZWFyJTIwc2hvcnRzfGVufDB8fHx8MTc5Mjk3MTg1NHww&ixlib=rb-4.1.0&q=85',
        alt: 'Shorts preview — stand-in photography',
      },
      {
        id: 'hats',
        name: 'Hats',
        badge: 'Drop 001 • Preview',
        image:
          'https://images.unsplash.com/photo-1521369909029-2afed882baee?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwyfHxzdHJlZXR3ZWFyJTIwaGF0JTIwY2FwfGVufDB8fHx8MTc5Mjk3MTg1NHww&ixlib=rb-4.1.0&q=85',
        alt: 'Hat preview — stand-in photography',
      },
    ],
  },
  contact: {
    eyebrow: 'Connect / Inquire',
    title: 'Reach YUNTI',
    support: 'Questions regarding Drop 001, wholesale perspective, or self-expression inquiries.',
    email: '',
  },
  footer: {
    shop: 'Shop',
    contact: 'Contact',
    instagram: 'Instagram',
    instagramUrl: '',
    copyright: '© YUNTI',
    collection: 'Perspective Collection',
  },
  theme: {
    purple: '#7e22ce',
    green: '#14532d',
    ground: '#FAF9F6',
    ink: '#121212',
    displayFont: 'anton',
    density: 'regular',
  },
};

// Deep-merge published CMS content over the defaults so new fields added
// later never break older published documents.
export function mergeContent(base, override) {
  if (Array.isArray(base) || Array.isArray(override)) return override !== undefined ? override : base;
  if (typeof base === 'object' && base !== null && typeof override === 'object' && override !== null) {
    const out = { ...base };
    for (const key of Object.keys(override)) out[key] = mergeContent(base[key], override[key]);
    return out;
  }
  return override !== undefined ? override : base;
}
